import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { CedulaDigital } from 'src/app/models/ceduladigital';
import {ActivatedRoute, Router} from '@angular/router';
import { CedulaDigitalService } from '../../services/ceduladigital.service';

@Component({
  selector: 'app-acreditaciones',
  templateUrl: './cedulas.component.html',
  styleUrls: ['./cedulas.component.css']
})
export class CedulasComponent implements OnInit {
  muestraDescarga:boolean = false;
  muestraEncuesta:boolean = false;
  cedulas: CedulaDigital[] = [];
  pdfSrc:string;
  idCedula:number;
  mostrarTabla:boolean = true;
  cedulaUpdate: CedulaDigital = new CedulaDigital();
  constructor(private cedulaDigitalService:CedulaDigitalService,
    private activateRouter: ActivatedRoute,private router:Router ) {
      this.muestraDescarga = false;
     }

  ngOnInit(): void {
    //primeramente ogtenemos el token

    this.activateRouter.params.subscribe(
      params => {
        let rfc = params['rfc'];
        if(rfc){
          this.cedulaDigitalService.getCedulas(rfc).subscribe(
            (cedulas) => {
              this.cedulas = cedulas;
              if(this.cedulas.length > 0){
                this.mostrarTabla = true;
              }
          }, (err)=>{
            this.mostrarTabla = false;
          });
      }
    
    
  });
}
  actualizaConstancia(cedula: CedulaDigital):void{

    swal.fire({
      title: 'Aviso',
      text: 'Se Recomienda, Completar El Proceso De Descarga.',
      icon: 'warning',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Enterado'
    }).then((result) => {
      if (result.isConfirmed) {
        this.cedulaUpdate = cedula;
          this.cedulaDigitalService.updateConstancia(this.cedulaUpdate).subscribe(
            response =>{
              swal.fire('Cédula Disponible', 'Descarge La Misma, Dando Clic En El Botón "Descargar Cédula"', 'success');
              this.muestraDescarga=true;
              this.muestraEncuesta = true;
              this.cedulaDigitalService.getCedulas(cedula.rfc).subscribe(
                cedulas => this.cedulas = cedulas);
              this.cedulas?.filter(cli => cli !== this.cedulaUpdate);
              if(this.cedulas.length > 0){
                this.mostrarTabla = true;
              }else{
                this.mostrarTabla = false;
              }
            }
            )
            
            this.router.navigate(['/cedulas', cedula.rfc]);

            //this.pdfSrc="http://cnsfdesmic3:9009/cnsf/agentesDescargaCedula/ver/" + cedula.id; //>>>>DESARROLLO
            //this.pdfSrc="https://cnsfdesmic3.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula/ver/" + cedula.id; //>>>>DESARROLLOv2

            //this.pdfSrc=='https://cnsfdesprorr.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula/ver/' + cedula.id;
            
            this.pdfSrc=='https://ceduladigital.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula/ver/' + cedula.id; //>>>>PRODUCCION
            
            //this.pdfSrc=='https://ceduladigitaldrp.cnsf.gob.mx/zuulO2/cnsf/agentesDescargaCedula/ver/' + cedula.id; //>>>>DRP
            
            this.idCedula = cedula.id;
          }
        
        
      }
    )
}

   
mostrarPDF():void{
  this.cedulaDigitalService.downloadPdf(this.idCedula).subscribe(
    x => {
      var newBlob = new Blob([x], { type: "application/pdf" });
      
      //if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveOrOpenBlob(newBlob, this.idCedula+'');
        //window.navigator.msSaveOrOpenBlob(newBlob, this.idCedula+'');
        return;
      }

      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
            link.href = data;
            link.download = this.idCedula+'';
            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
            
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
                link.remove();
            }, 100);

    });
    this.muestraDescarga = false;
    if(this.cedulas.length > 0){
      this.mostrarTabla = true;
    }else{
      this.mostrarTabla = false;
    }
}


  refrescaVentana(){
    this.muestraDescarga = false;
    this.muestraEncuesta = false;
    if(this.cedulas.length > 0){
      this.mostrarTabla = true;
    }else{
      this.mostrarTabla = false;
    }
  }

  salir():void{
    localStorage.setItem("token", "");
    this.router.navigate(['/cedulas']);
  }
}
